<template>
  <div>
    <a v-if="show" class="product-button ripple-animation ripple-animation--black" @click="submit">
      {{ buynowText }}</a
    >
    <div>
      <div
        v-if="showPopUp"
        class="mctb_popup_03_ mctb-modal-mask"
        style="background-color: rgb(0 0 0 / 6%); top: 3% !important"
      >
        <div class="mctb_popup_04_ mctb-modal-wrapper">
          <div
            class="mctb_popup_05_ mctb-modal-container cc-modal-container"
            style="box-shadow: 0 2px 8px rgb(0 0 0 / 5%)"
          >
            <div class="mctb_popup_06_ mctb-carousel-mode-header">
              <button class="mctb_popup_07_ mctb-modal-close" @click="submit">X</button>

              <div class="mctb_popup_08_ mctb-carousel-mode-header-top-header">{{ PRODUCT }}</div>

              <ul
                v-if="SHOP_LIST && SHOP_LIST.length"
                class="mctb-retailer-list"
                style="display: flex; flex-wrap: wrap"
              >
                <li
                  v-for="(shop, index) in SHOP_LIST"
                  :key="index"
                  class="cc-column"
                  style="padding: 5px !important"
                >
                  <a class="mctb_popup_09_ mctb-retailer-item">
                    <div class="mctb_popup_10_ mctb-retailer-image">
                      <img class="mctb_popup_11_" :src="shop.logo" :alt="shop.productName" />
                    </div>
                    <button
                      class="mctb_popup_13_ mctb-retailer-buynow"
                      @click="pageRedirectUrl(shop.link, shop.addToCartTagging)"
                    >
                      <span class="mctb_popup_14_"> {{ shop.buyButton }}</span>
                    </button>
                  </a>
                </li>
              </ul>
              <div v-else style="text-align: center">{{ jsonData.defaultDescriptionTitle }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';

export default {
  name: 'commerce-connector',
  props: {
    productDataId: {
      type: String,
      default: '',
    },
    buynowText: {
      type: String,
      required: true,
    },
    show: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showPopUp: false,
      jsonData: {
        shops: [],
      },
    };
  },
  computed: {
    PRODUCT() {
      return this.jsonData.descriptionProduct;
    },
    SHOP_LIST() {
      return this.jsonData.shops;
    },
  },
  methods: {
    getRetailers(itemId = this.productDataId) {
      if (!itemId) return;
      axios
        .get('/api/sitecore/CommerceConnector/CommerceConnector?itemId=' + itemId, {
          headers: { Pragma: 'no-cache' },
        })
        .then((response) => {
          if (response && response.data && response.data.length) {
            this.jsonData = response.data[0];
            dataLayer.push({
              event: 'uaevent',
              eventCategory: 'Ecommerce',
              eventAction: 'click to buy',
              eventLabel: `${this.jsonData.descriptionProduct.toLowerCase()}::${this.jsonData.productId}`,
              event_name: 'buy_now',
              product_info: `${this.jsonData.descriptionProduct.toLowerCase()}::${this.jsonData.productId}`,
              ecommerce: 'undefined',
            });
            this.showPopUp = true;
          }
        });
    },
    submit() {
      if (!this.showPopUp) {
        this.getRetailers();
      } else {
        this.showPopUp = false;
      }
    },
    pageRedirectUrl(redirectURL, addtoCartTagging) {
      this.dataLayerPush(addtoCartTagging);
      window.open(redirectURL, '_blank');
    },
    dataLayerPush(taggingVal) {
      try {
        const eventData = typeof taggingVal === 'string' ? JSON.parse(taggingVal) : taggingVal;
        window.dataLayer.push(eventData);
      } catch (error) {
        console.warn('Failed to parse tagging:', error);
      }
    },
  },
};
</script>
<style lang="postcss" scoped>
@media screen and (width >= 768px) and (width <= 1023px) {
  .cc-modal-container {
    width: 47% !important;
  }
}

@media screen and (width >= 375px) and (width <= 480px) {
  .cc-column {
    width: 100% !important;
  }
}

.cc-column {
  float: left;
  width: 45%;
  margin: 5px;
}
</style>
